// prettier-ignore
const vatList = {BE:1.21,BG:1.2,DK:1.25,DE:1.19,EE:1.2,FI:1.24,FR:1.2,GR:1.24,IE:1.23,IT:1.22,HR:1.25,LV:1.21,LT:1.21,LU:1.17,MC:1.2,MT:1.18,NL:1.21,AT:1.2,PL:1.23,PT:1.23,RO:1.19,SE:1.25,SK:1.2,SI:1.22,ES:1.21,CZ:1.21,HU:1.27,CY:1.19};

window.calculatePricesWithVat = () => {
  function getCookie(name) {
    name = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
  }

  const nonVatPriceElements = document.querySelectorAll("[data-non-vat-price]");
  const currentVat = vatList[getCookie("localization")] || 1;

  nonVatPriceElements.forEach((priceEl) => {
    if (priceEl.getAttribute("data-non-vat-price") > 0) {
      priceEl.innerHTML = Shopify.formatMoney(
        priceEl.getAttribute("data-non-vat-price") * currentVat,
        "€{{amount_with_comma_separator}}"
      );
    }
  });
};
window.calculatePricesWithVat();
